"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmailEngagementStats = exports.EMPTY_ENGAGEMENT_COUNTS = exports.HUMAN_EMAIL_ENGAGEMENT_CUTOVER_UTC = void 0;
const email_1 = require("./email");
exports.HUMAN_EMAIL_ENGAGEMENT_CUTOVER_UTC = new Date("2026-10-01T10:00:00Z");
exports.EMPTY_ENGAGEMENT_COUNTS = {
    deliveredCount: 0,
    openedCount: 0,
    clickedCount: 0,
    purchasedCount: 0,
    humanEligibleCount: 0,
    humanOpenedCount: 0,
    humanClickedCount: 0,
    humanPurchasedCount: 0,
    unknownCount: 0,
};
const getEmailEngagementStats = ({ counts, isOngoing, hasSendsBeforeCutover, hasSendsSinceCutover, isHumanEngagementEnabled, }) => {
    const isMeasuredByHumanEngagement = isOngoing ? hasSendsSinceCutover : !hasSendsBeforeCutover;
    if (isHumanEngagementEnabled && isMeasuredByHumanEngagement) {
        const isAllPrivate = counts.humanEligibleCount > 0 && counts.unknownCount === counts.humanEligibleCount;
        return {
            method: "human",
            openRate: isAllPrivate
                ? null
                : (0, email_1.calculateEmailStatPercentages)(counts.humanOpenedCount, counts.humanEligibleCount - counts.unknownCount),
            clickRate: (0, email_1.calculateEmailStatPercentages)(counts.humanClickedCount, counts.humanEligibleCount),
            purchasedCount: counts.humanPurchasedCount,
            unknownCount: counts.unknownCount,
            isAllPrivate,
        };
    }
    return {
        method: isHumanEngagementEnabled ? "previous" : "raw",
        openRate: (0, email_1.calculateEmailStatPercentages)(counts.openedCount, counts.deliveredCount),
        clickRate: (0, email_1.calculateEmailStatPercentages)(counts.clickedCount, counts.deliveredCount),
        purchasedCount: counts.purchasedCount,
        unknownCount: 0,
        isAllPrivate: false,
    };
};
exports.getEmailEngagementStats = getEmailEngagementStats;
